import { useProjects } from "../../data/projects";
import { useHome } from "../../data/content";
import Emphasis from "../../components/Emphasis";
import StatItem from "./StatItem";

const roundDown5 = (n) => (n % 5 === 0 ? n - 5 : Math.floor(n / 5) * 5);

function ExperienceHeader() {
  const projects = useProjects();
  const home = useHome();

  // Years ticks over on its own each January. Projects and clients count what is
  // published unless a number is set in the CMS, which then wins.
  const years = Math.max(0, new Date().getFullYear() - (home.startYear ?? new Date().getFullYear()));
  const projectCount = home.projectsCount ?? roundDown5(projects.length);
  const uniqueClients = new Set(projects.map((p) => p.client)).size;
  const clientCount = home.clientsCount ?? Math.max(15, roundDown5(uniqueClients));

  const stats = [
    { value: `${years}+`, label: "Years" },
    { value: `${projectCount}+`, label: "Projects" },
    { value: `${clientCount}+`, label: "Clients" },
  ];

  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
      {/* Left */}
      <div>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-px bg-text-muted-light dark:bg-text-muted-dark" />
          <span className="font-sans text-xs tracking-[0.3em] text-text-muted-light dark:text-text-muted-dark uppercase">
            {home.experienceEyebrow}
          </span>
        </div>

        <h2 className="font-sans font-bold text-4xl md:text-5xl text-text-primary-light dark:text-text-primary-dark leading-tight mb-3">
          <Emphasis>{home.experienceHeading}</Emphasis>
        </h2>

        <p className="font-sans text-sm text-text-muted-light dark:text-text-muted-dark max-w-xs leading-relaxed">
          {home.experienceBlurb}
        </p>
      </div>

      {/* Stats */}
      <div className="flex items-center">
        {stats.map((stat, i) => (
          <StatItem key={stat.label} {...stat} divider={i > 0} />
        ))}
      </div>
    </div>
  );
}

export default ExperienceHeader;
